import { all } from 'redux-saga/effects';
import watchUpdate from './update';
import watchGet from './get';

export function* watchIt() {
  yield all([watchGet(), watchUpdate()]);
}
